import { PolygonLayer } from "@deck.gl/layers"
import { ScanAreaData } from "features/entity-caching/flights/types"
import { useAppSelector } from "integrations/redux/hooks"
import { selectOrthoScanAreaData } from "features/entity-caching/flights/selectors"

export const useRGBOrthoScanAreaLayer = () => {
    const scanAreas = useAppSelector(selectOrthoScanAreaData())
    return new PolygonLayer<ScanAreaData>({
        id: "ortho-scan-areas",
        visible: true,
        data: scanAreas,
        getPolygon: (d) => {
            return d.coordinates.map((coord) => [coord.longitude, coord.latitude])
        },
        getFillColor: (d) => d.fillColor,
        getLineColor: (d) => d.outlineColor,
        pickable: true,
        lineWidthUnits: "pixels",
        getLineWidth: (d) => d.outlineThickness,
    })
}
